"use strict";

var curry = require("./curry.js");

var extend = require("./extend.js");

var reverse = require("./reverse.js");

var go = require("./go.js");

var apply = require("./apply.js");

const extendRight = (...objs) => go(objs, reverse, apply(extend));

module.exports = curry(extendRight);